import { render, staticRenderFns } from "./ProjectRegistrationVariables.vue?vue&type=template&id=ada074ee&"
import script from "./ProjectRegistrationVariables.vue?vue&type=script&lang=js&"
export * from "./ProjectRegistrationVariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports